import { HTTPError } from 'ky';
import clsx from 'clsx';
import useI18n from '@i18n';

export interface IError {
    requestId: string;
}
export interface IBaseErrorProps {
    id?: string;
    error?: HTTPError | IError;
    message?: string;
    className?: string;
}

const BaseError: React.FC<IBaseErrorProps> = ({
    id = '',
    error,
    className = '',
    message = 'Failed to load data',
}) => {
    const { t } = useI18n();
    const requestId =
        (error as IError)?.requestId || (error as HTTPError)?.response?.headers?.get('request-id');

    return (
        <div id={id} className={clsx('p-20 text-center text-p1', className)}>
            {t(message)}
            {requestId && <p className="font-medium">request-id: {requestId}</p>}
        </div>
    );
};

export default BaseError;
